/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Join_Notice_TitleInputs */

const en_us2_clubs_join_notice_title = /** @type {(inputs: Clubs_Join_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How this club works`)
};

const pt_br2_clubs_join_notice_title = /** @type {(inputs: Clubs_Join_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como este clube funciona`)
};

const es_419_clubs_join_notice_title = /** @type {(inputs: Clubs_Join_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona este club`)
};

const pt_pt2_clubs_join_notice_title = /** @type {(inputs: Clubs_Join_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona este clube`)
};

const fr_fr2_clubs_join_notice_title = /** @type {(inputs: Clubs_Join_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionne ce club`)
};

const de_de2_clubs_join_notice_title = /** @type {(inputs: Clubs_Join_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So funktioniert dieser Club`)
};

const it_it2_clubs_join_notice_title = /** @type {(inputs: Clubs_Join_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona questo club`)
};

/**
* | output |
* | --- |
* | "How this club works" |
*
* @param {Clubs_Join_Notice_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_join_notice_title = /** @type {((inputs?: Clubs_Join_Notice_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Join_Notice_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_join_notice_title(inputs)
	if (locale === "es-419") return es_419_clubs_join_notice_title(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_join_notice_title(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_join_notice_title(inputs)
	if (locale === "de-DE") return de_de2_clubs_join_notice_title(inputs)
	if (locale === "it-IT") return it_it2_clubs_join_notice_title(inputs)
	return en_us2_clubs_join_notice_title(inputs)
});
export { clubs_join_notice_title as "clubs.join_notice_title" }